module.exports = __webpack_public_path__ + "static/media/mobileScreenshot03.6fcbf7a2.jpg";